<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<Props>()
const now = useNow()
const minutesLater = computed(() => now.value.getTime() + 1000 * 60 * 10)

const formattedDate = computed(() => {
  const date = new Date(minutesLater.value)
  return date.toLocaleString('ru-RU', {
    hour: 'numeric',
    minute: 'numeric',
  }).split(':')
})

interface Props {
  class?: HTMLAttributes['class']
}
</script>

<template>
  <GradientButton :class="props.class">
    <span>
      Получить деньги
    </span>
    <ClientOnly>
      <span>
        в
        {{ formattedDate[0] }}<span :class="{ 'opacity-0': now.getSeconds() % 2 === 0 }">:</span>{{ formattedDate[1] }}
      </span>
    </ClientOnly>
  </GradientButton>
</template>

<style scoped>

</style>
